module.exports = __webpack_public_path__ + "static/media/semoladetrigo.7f4c62d0.png";